import { render } from "./AiConfig.vue?vue&type=template&id=561f3adc&scoped=true"
import script from "./AiConfig.vue?vue&type=script&lang=js"
export * from "./AiConfig.vue?vue&type=script&lang=js"

import "./AiConfig.vue?vue&type=style&index=0&id=561f3adc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561f3adc"]])

export default __exports__